import { toast } from "react-toastify";
import AutomaticSystemsApi from "./api";
import AutomaticSystemsTypes from "./types";
import IntlUtils from "services/intl/utils";

class AutomaticSystemsActioner {
  static setAutomaticSystems(data) {
    return {
      type: AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS,
      data,
    };
  }

  static setAutomaticSystemsDetails(id, data) {
    return {
      type: AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_DETAILS,
      id,
      data,
    };
  }

  static setAutomaticSystemsLoading(loading) {
    return {
      type: AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_LOADING,
      loading,
    };
  }

  static setAutomaticSystemsDetailsLoading(id, loading) {
    return {
      type: AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_DETAILS_LOADING,
      id,
      loading,
    };
  }

  static setAutomaticSystemsStatusLoading(id, loading) {
    return {
      type: AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_STATUS_LOADING,
      id,
      loading,
    };
  }

  static setAutomaticSystemsModeLoading(id, loading) {
    return {
      type: AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_MODE_LOADING,
      id,
      loading,
    };
  }

  static retrieveAutomaticSystems = () => {
    return (dispatch, getState) => {
      const data = {
        contract_id: getState().Contract.contract.id,
      };

      dispatch(AutomaticSystemsActioner.setAutomaticSystemsLoading(true));

      return AutomaticSystemsApi.getAutomaticSystems(data)
        .then((res) => {
          dispatch(AutomaticSystemsActioner.setAutomaticSystems(res));
          dispatch(AutomaticSystemsActioner.setAutomaticSystemsLoading(false));
          return res;
        })
        .catch((err) => {
          dispatch(AutomaticSystemsActioner.setAutomaticSystemsLoading(false));
          return Promise.reject(err);
        });
    };
  };

  static retrieveAutomaticSystemsDetails = (id) => {
    return (dispatch, getState) => {
      const data = {
        contract_id: getState().Contract.contract.id,
      };

      dispatch(
        AutomaticSystemsActioner.setAutomaticSystemsDetailsLoading(id, true)
      );

      return AutomaticSystemsApi.getAutomaticSystemsDetails(id, data)
        .then((res) => {
          dispatch(
            AutomaticSystemsActioner.setAutomaticSystemsDetails(id, res)
          );
          dispatch(
            AutomaticSystemsActioner.setAutomaticSystemsDetailsLoading(
              id,
              false
            )
          );
          return res;
        })
        .catch((err) => {
          dispatch(
            AutomaticSystemsActioner.setAutomaticSystemsDetailsLoading(
              id,
              false
            )
          );
          return Promise.reject(err);
        });
    };
  };

  static updateAutomaticSystemsMode(id, data) {
    return (dispatch, getState) => {
      const contractId = getState().Contract.contract.id;

      dispatch(
        AutomaticSystemsActioner.setAutomaticSystemsModeLoading(id, true)
      );

      return AutomaticSystemsApi.updateAutomaticSystemsMode(
        contractId,
        id,
        data
      )
        .then((res) => {
          const intl = IntlUtils.getIntlInstance();
          const msg = intl.messages["automaticSystemsScene.toast.modeChanged"];

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.SUCCESS,
          });
          dispatch(
            AutomaticSystemsActioner.retrieveAutomaticSystemsDetails(id)
          );
          dispatch(
            AutomaticSystemsActioner.setAutomaticSystemsModeLoading(id, false)
          );
          return res;
        })
        .catch((err) => {
          const intl = IntlUtils.getIntlInstance();
          const msg = intl.messages["toast.errors.errorOccuredContactSupport"];

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
          dispatch(
            AutomaticSystemsActioner.setAutomaticSystemsModeLoading(id, false)
          );
        });
    };
  }

  static updateAutomaticSystemsStatus(id, data) {
    return (dispatch, getState) => {
      const contractId = getState().Contract.contract.id;
      dispatch(
        AutomaticSystemsActioner.setAutomaticSystemsStatusLoading(id, true)
      );
      return AutomaticSystemsApi.updateAutomaticSystemsStatus(
        contractId,
        id,
        data
      )
        .then((res) => {
          const intl = IntlUtils.getIntlInstance();
          const msg =
            intl.messages["automaticSystemsScene.toast.statusChanged"];

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.SUCCESS,
          });
          dispatch(
            AutomaticSystemsActioner.retrieveAutomaticSystemsDetails(id)
          );
          dispatch(
            AutomaticSystemsActioner.setAutomaticSystemsStatusLoading(id, false)
          );
          return res;
        })
        .catch((err) => {
          const intl = IntlUtils.getIntlInstance();
          const msg = intl.messages["toast.errors.errorOccuredContactSupport"];

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
          dispatch(
            AutomaticSystemsActioner.setAutomaticSystemsStatusLoading(id, false)
          );
        });
    };
  }
}

export default AutomaticSystemsActioner;
